import { useEffect, useState } from 'react';

const useCountdown = () => {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const start = (seconds: number) => {
    setCountdown(seconds);
  };

  return { countdown, start };
};

export { useCountdown };
